import { useInfiniteQuery } from "@tanstack/react-query"
import { client } from "@/api"

// Slice 6: individual transactional sends from email_events (COMMS_DB), newest
// first, keyset-paginated by id. Mirrors the backend EmailLogItem/EmailLogPage.
export interface EmailLogItem {
  publicId: string
  provider: string
  type: string
  status: string
  toEmail: string
  fromEmail: string
  messageId: string | null
  teamPublicId: string | null
  invitationPublicId: string | null
  actorPublicId: string | null
  error: string | null
  subject: string | null
  createdAt: string
  updatedAt: string
}

export interface EmailLogPage {
  items: EmailLogItem[]
  /** Opaque cursor for the next (older) page; null when exhausted. */
  nextCursor: string | null
}

export interface EmailLogFilters {
  status?: string
  type?: string
  q?: string
  /** Window in days; undefined = all time. */
  window?: number
}

const PAGE_SIZE = 50

export function useEmailLog(filters: EmailLogFilters) {
  return useInfiniteQuery({
    queryKey: ["admin", "email-log", filters],
    initialPageParam: undefined as string | undefined,
    queryFn: async ({ pageParam }) => {
      const query = {
        limit: PAGE_SIZE,
        ...(filters.status ? { status: filters.status } : {}),
        ...(filters.type ? { type: filters.type } : {}),
        ...(filters.q ? { q: filters.q } : {}),
        ...(filters.window ? { window: filters.window } : {}),
        ...(pageParam ? { before: pageParam } : {}),
      }
      const response = await client.admin.email.log.$get({ query })
      if (!response.ok) {
        throw new Error("Failed to fetch email log")
      }
      return response.json() as Promise<EmailLogPage>
    },
    getNextPageParam: (lastPage) => lastPage.nextCursor ?? undefined,
  })
}
